import { render, staticRenderFns } from "./PchProviderPaymentCreate.vue?vue&type=template&id=ce8af8aa&lang=pug&"
import script from "./PchProviderPaymentCreate.vue?vue&type=script&lang=js&"
export * from "./PchProviderPaymentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PchProviderPaymentCreate.vue"
export default component.exports